import React from 'react';

/**
 * Latency (E2E) metric card.
 * Shows p50 big number, a segmented p50/p95/p99 bar, and a legend.
 */
const LatencyCard = ({ latency }) => {
    const { p50Ms = 0, p95Ms = 0, p99Ms = 0 } = latency || {};
    const total = p50Ms + p95Ms + p99Ms;
    const p50Pct = total > 0 ? (p50Ms / total) * 100 : 33;
    const p95Pct = total > 0 ? (p95Ms / total) * 100 : 33;
    const p99Pct = total > 0 ? (p99Ms / total) * 100 : 34;
    const p99Ratio = p50Ms > 0 ? (p99Ms / p50Ms).toFixed(1) : '—';

    return (
        <div className="metric-card">
            <div className="metric-card__header">
                <div className="metric-card__label">Latency (E2E)</div>
                <span className="latency-card__p99-note">p99 = {p99Ratio}x median</span>
            </div>

            <div className="metric-card__big-row">
                <span className="metric-card__big-number">
                    {p50Ms}<span className="metric-unit">ms</span>
                </span>
                <span className="metric-card__peak">p50 · expected {p50Ms}</span>
            </div>

            {/* Segmented bar */}
            <div>
                <div className="latency-bar">
                    <div
                        className="latency-bar__segment latency-bar__segment--p50"
                        style={{ flex: `0 0 ${p50Pct}%` }}
                    />
                    <div
                        className="latency-bar__segment latency-bar__segment--p95"
                        style={{ flex: `0 0 ${p95Pct}%` }}
                    />
                    <div
                        className="latency-bar__segment latency-bar__segment--p99"
                        style={{ flex: `0 0 ${p99Pct}%` }}
                    />
                </div>
                <div className="latency-bar__labels">
                    <span>p50</span>
                    <span>p95</span>
                    <span>p99</span>
                </div>
            </div>

            {/* Legend */}
            <div className="latency-legend">
                <div className="latency-legend__row">
                    <span className="latency-legend__name">
                        <span className="latency-legend__dot" style={{ background: 'var(--semantic-graph-series-01, #1753FF)' }} />
                        p50
                    </span>
                    <span className="latency-legend__value">{p50Ms}</span>
                </div>
                <div className="latency-legend__row">
                    <span className="latency-legend__name">
                        <span className="latency-legend__dot" style={{ background: 'var(--semantic-graph-series-02, #C483FB)' }} />
                        p95
                    </span>
                    <span className="latency-legend__value">{p95Ms}</span>
                </div>
                <div className="latency-legend__row">
                    <span className="latency-legend__name">
                        <span className="latency-legend__dot" style={{ background: 'var(--semantic-graph-series-04, #FCB887)' }} />
                        p99
                    </span>
                    <span className="latency-legend__value">{p99Ms}</span>
                </div>
            </div>
        </div>
    );
};

export default LatencyCard;
